import { Link } from 'react-router-dom'

import styled from 'styled-components'

import { Container } from '../../../styles/global'
import chevronLeft from '../../../assets/icons/arrow-chevron-left.svg'
import chevronRight from '../../../assets/icons/arrow-chevron-right.svg'

export const BoxContainer = styled(Container)`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: start;
`
export const Header = styled.div`
  display:flex;
  justify-content:space-between;
  align-items:flex-end;
  background: #fff;
  padding: 16px;
  ${props => props.isSticky && 'position:fixed;top:0;left:0;right:0;z-index:1;padding:15px;margin-top:-10px;'}
`
export const Month = styled(Link)`
  width: 132px;
  height: 48px;
  display:flex;
  align-items:center;
  justify-content: center;
  color:#0595A6;
  border: 1px solid #01878E;
  border-radius: 4px;

  img {
    width: 16px;
  }

  span{
    font-weight:700;
    font-size:16px;
    line-height: 16px;
    margin-left:10px;
    text-transform:capitalize;
  }
`
export const Day = styled.div`
  display:flex;
  flex-direction:column;
  color:#0595A6;
  font-weight:700;
  justify-content:center;
  align-items:center;

  span{
    text-transform:capitalize;
  }
`
export const Navigation = styled.div`
  display:flex;
  align-items:center;
  margin-top:5px;
`
export const DayNumber = styled.div`
  border-radius:50%;
  background:#0595A6;
  color:#fff;
  width:45px;
  height:45px;
  display:flex;
  align-items:center;
  justify-content:center;
  font-size:30px;
  margin:0 30px;
`
export const ButtonLeft = styled.button`
  background:none;
  background-image: url(${chevronLeft});
  background-repeat:no-repeat;
  background-size:100%;
  background-position:center;
  width:12px;
  height:21px;
  border:none;
`
export const ButtonRight = styled.button`
  background:none;
  background-image: url(${chevronRight});
  background-repeat:no-repeat;
  background-size:100%;
  background-position:center;
  border:none;
  width:12px;
  height:21px;
`
export const List = styled.div`
  display:flex;
  flex-direction:column;
  gap: 15px;
`
export const Message = styled.small`
  width:100%;
  text-align:center;
  margin:auto;
  color:#0595A6;
  font-size:14px;
  font-weight:700;
  margin-top:25%;
`
